import './App.css';
import Header from './components/Header';
import Weather from './components/Weather';
import Footer from './components/Footer';
import React from 'react';

function App() {
  return (
    <>
      <Header />
      <Weather />
      <Footer />
    </>
  );
}

export default App;
